<template>
    <div class="b3-dialog-box" v-show="store.state.showingModal==='browser'">
        <div class="b3-modal project-result">
            <div
                class="cancel-button"
                @click="unselectFile"
            >
                <Icon icon="cancel" />
            </div>
            <div v-if="store.state.selectedFile">
                <ProjectEntry :project="store.state.selectedFile" v-if="mode === 'view'" />
                <div class="edit-entry" v-if="mode === 'edit'">
                    <div class="b3-form-option">
                        <label>{{t('project title text input','Project Title')}}</label>
                        <input v-model="updated.title" type="text" maxlength="100" :placeholder="t('enter title placeholder', 'Enter title here')">
                    </div>
                    <div class="b3-form-option">
                        <label >{{caps(t('tags','Tags'))}}</label>
                        <input v-model="updated.tags" type="text" maxlength="100" :placeholder="t('tags separated by commas', 'Tags separated by commas')">
                    </div>
                    <div class="b3-form-option">
                        <label>{{caps(t('description','Description'))}}</label>
                        <textarea
                            v-model="updated.description"
                            :placeholder="t('enter description placeholder', 'Enter description here')"
                        ></textarea>
                    </div>
                    <div class="b3-form-option">
                        <label>{{t('credits','Credits')}}</label>
                        <textarea v-model="updated.credits" :placeholder="t('enter credits placeholder', 'Enter credits here')"></textarea>
                    </div>
                    <div class="table-button-area">
                        <button @click="updateFile">{{t('update','Update')}}</button>
                        <button class="quiet-button" @click="mode = 'view'">{{t('cancel','Cancel')}}</button>
                    </div>
                </div>
            </div>
            <div id="browser-modal-buttons">
                <button :title="t('open','Open')" @click="openSelectedFile" class="success-button" :disabled="isCurrentlyOpen"><Icon class="nudge-down-2" icon="launch"/></button>
                <button :title="t('edit','Edit')" @click="launchEdit"><Icon icon="edit"/></button>
                <button :title="t('duplicate project','Duplicate project')" @click="duplicateFile"><Icon icon="content_copy"/></button>
                <button :title="t('download project','Download project')" @click="downloadSelectedFile"><Icon icon="file_download"/></button>
                <button :title="t('delete','Delete')" @click="deleteSelectedFile" class="warning-button" :disabled="isCurrentlyOpen" ><Icon icon="delete"/></button>
            </div>
        </div>
    </div>
</template>

<script>
import { caps, lang } from '../myapp/src/lang';
import { settings } from '../myapp/src/settings';
import { save } from '../myapp/src/projects/save';
import { project } from '../myapp/src/projects/project';
import { load } from '../myapp/src/projects/load';
import { utils } from '../myapp/src/utils';
import { beadCloud } from '../myapp/src/core/azure';
import Icon from '../components/Icon.vue';
import ProjectEntry from '../components/ProjectEntry.vue';

export default {
    name: 'Browser Modal',
    data() {
        return {
            mode: 'view',
            updated: {
                title: '',
                description: '',
                credits: '',
                tags: []
            }
        }
    },
    methods: {
        async openSelectedFile() {
            b3.store.mySet('showingModal', null);
            const fileObject = await beadCloud({
                fn: 'getItemFromId',
                params: {
                    id: this.store.state.selectedFile.id,
                    container: 'projects'
                }
            });
            if (fileObject?.error) return;
            load.project({fileObject});
        },
        launchEdit() {
            if (this.mode === 'edit') return;
            ['title', 'description', 'credits'].forEach(key => {
                this.updated[key] = this.store.state.selectedFile[key];
            })
            this.updated.tags = this.store.state.selectedFile.tags.join(', ');
            this.mode = 'edit';
        },
        updateFile() {
            const shouldUpdateTagList = this.updated.tags !== this.store.state.selectedFile.tags.join(', ');
            save.updateMetaData({
                ...this.updated,
                tags: utils.processUserInputTagStr(this.updated.tags),
                selectedFile: this.store.state.selectedFile,
                shouldUpdateTagList
            });
            this.mode = 'view';
        },
        duplicateFile() {

            const doDuplicate = () => {
                save.duplicate({
                    selectedFile: this.store.state.selectedFile,
                    title: this.store.state.dialogBox.textInputValue
                });
                b3.store.mySet('showingModal', null);
                b3.hideModal();
            };

            const prompt = lang.get('name duplicate prompt', 'Enter name of copy')

            b3.renderModal(prompt, doDuplicate, null, true);
        },
        downloadSelectedFile() {
            save.downloadById(this.store.state.selectedFile.id);
        },
        unselectFile() {
            this.mode = 'view';
            this.store.mySet('showingModal', null);
            this.store.mySet('selectedFile', null);
        },
        deleteSelectedFile() {
            const doDelete = () => {
                project.deleteFile(this.store.state.selectedFile.id);
                b3.store.mySet('showingModal', null);
                b3.hideModal();
            };
            const prompt = this.t('delete project prompt', 'Delete this project?');

            b3.renderModal(prompt, doDelete, null);
        },
        caps,
    },
    computed: {
        isCurrentlyOpen: function () {
            return this.store.state.selectedFile ?
                this.store.state.selectedFile.id === settings.currentProjectId:
                false;
        }
    },
    components: { Icon, ProjectEntry }
}
</script>

<style lang="scss">
@import '../assets/colors.scss';

.nudge-down-2 {
    position: relative;
    top: 2px;
}

.edit-entry {
    background-color: $off_white;
    padding: 20px;
    border-radius: 5px;
    width: 500px;
}

.project-result {
    max-height: calc(100vh - 60px);
    overflow-y: auto;
    .cancel-button {
        position: absolute;
        left: 521px;
        top: 14px;
        &:hover {
            color: $warning;
            cursor: pointer;
        }
    }
    top: 50px;
    background-color: $b_theme;
    border-style: solid;
    border-color: $dark_grey;
    border-radius: 5px;
    padding: 10px;

    .project-entry {
        display: flex;
        background-color: $off_white;
        border-radius: 5px;
        width: 500px;
        padding: 20px;

        .col {
            width: 50%;
        }
        .project-image {
            width: 175px;
        }

        .text-display-area {
            background-color: white;
            padding: 10px;
            border-radius: 5px;
            max-height: 150px;
            overflow-y: auto;
        }

        .project-details {
            font-size: 14px;
            line-height: 0.3;
        }

        .section-header {
            font-weight: bold;
            padding: 10px 0;
        }
    }
    #browser-modal-buttons {
        padding-top: 10px;
        text-align: center;
        button {
            margin-left: 15px;
            margin-bottom: 5px;
        }
    }
}

@media only screen and (max-width: 600px) {

.project-result {
    top: 50px;
    background-color: $b_theme;
    border-style: solid;
    border-color: $dark_grey;
    border-radius: 5px;
    padding: 5px;
    width: 95%;

    .project-entry {
        display: block;
        background-color: $off_white;
        border-radius: 5px;
        width: 93%;
        padding: 10px;

        .col {
            width: 95%;
        }
        .project-image {
            width: 175px;
        }

        .text-display-area {
            background-color: white;
            padding: 10px;
            border-radius: 5px;
            max-height: 150px;
            overflow-y: auto;
        }

        .project-details {
            font-size: 14px;
            line-height: 0.3;
        }

        .section-header {
            font-weight: bold;
            padding: 10px 0;
        }
    }
    #browser-modal-buttons {
        padding-top: 10px;
        text-align: center;
        button {
            margin-left: 15px;
            margin-bottom: 5px;
        }
    }
}

}

</style>